angular.module('barometerApp.matrix')
    .directive('matrix', [function () {
        return {
            templateUrl: '/b/js/src/bit.ng/matrix/partials/matrix.html',
            scope: {
                previewMode: '@',
                worksheetBn: '='
            }
        }
    }]);